// components/Translate.jsx
import { useContext } from 'react';
import {  LanguageContext } from '../../context';

export const useTranslate = (text) => {


    var languages={
      he:require('../../languages/he.json'),
      en:require('../../languages/en.json')
    }
  const { language } = useContext(LanguageContext);

  // return the translated text or the original text
  if (Object.keys(languages).includes(language)) {
    return languages[language][text] || text;
  }

  return text;
};

const Translate = ({ children }) => {
  return useTranslate(children);
};

export default Translate;